export default __webpack_public_path__ + "static/media/GHSI Audit Committee Charter.b877361c.pdf";